
export default function PageLoader() {
	return (
		<div role="status" className="absolute inset-0 z-10 flex items-center justify-center bg-[#f3f3f0]/85 backdrop-blur-[2px] dark:bg-[#090a0c]/85">
			<div className="size-8 animate-spin rounded-full border-[3px] border-zinc-300 border-t-brand-500 motion-reduce:animate-none dark:border-white/20 dark:border-t-brand-500" aria-hidden="true" />
			<span className="sr-only">Se încarcă...</span>
		</div>
	);
}